import { Checkbox } from "antd";
import Text from "antd/lib/typography/Text";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import AdnToolTip from "../common/adnToolTip/AdnToolTip";
import ContactPanelForm from "./ContactPanelForm";

const ManageContactPanel = ({
  department,
  allSelected,
  setAllSelected,
  selectedContacts,
  setSelectedContacts,
  requiresFetch,
  ...props
}) => {
  const [selectedDepartment, setSelectedDepartment] = useState(false);
  const [selectCount, setSelectCount] = useState(0);

  const pageSize = 10;
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [orderBy, setOrderBy] = useState("");
  const [searchName, setSearchName] = useState("");

  useEffect(() => {
    department
      .fetch(currentPage, pageSize, orderBy, searchName)
      .then((res) => {
        if (res && res.data) {
          setTotalRecords(res.data.totalRecords);
          setData(res.data.result);
        } else {
          setData([]);
        }
      })
      .catch((err) => console.log(err));
  }, [currentPage, orderBy, searchName, requiresFetch]);

  // Update number of messages and state when all departments selected
  useEffect(() => {
    if (!data || data.length == 0) return;

    if (allSelected) {
      if (
        !selectedContacts.find(
          (contact) =>
            contact.type == "Department" && contact.name == department.name
        )
      ) {
        // if all is selected but the department hasn't been added to the state yet
        setSelectedContacts([
          ...selectedContacts,
          {
            type: "Department",
            id: department.id,
            name: department.name,
            count: totalRecords,
          },
        ]);
        setSelectCount(totalRecords);
        setSelectedDepartment(true);
      }
    } else {
      let count = 0;

      for (const contact of selectedContacts) {
        if (contact.type == "Department" && contact.name == department.name) {
          setSelectCount(totalRecords);
          return;
        }

        if (contact.type == department.name) count++;
      }

      if (count == 0) setSelectedDepartment(false);

      setSelectCount(count);
    }
  }, [selectedContacts]);

  const columns = [
    {
      title: (
        <Checkbox
          disabled={selectedDepartment}
          onChange={(e) => onCheckPage(e)}
          checked={
            !data.find(
              (record) =>
                !selectedContacts.find(
                  (contact) =>
                    record.id == contact.id && contact.type == department.name
                )
            )
          }
        />
      ),
      key: "add",
      render: (_, record) => (
        <Checkbox
          disabled={selectedDepartment}
          onChange={(e) => onCheck(e, record)}
          checked={
            selectedDepartment ||
            selectedContacts.findIndex(
              (contact) =>
                contact.type == department.name && contact.id == record.id
            ) > -1
          }
        />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
      render: (_, record) =>
        department.entityRoute ? (
          <Link
            to={department.entityRoute.createPath(record.id)}
            target="_blank"
          >
            {record.name}
          </Link>
        ) : (
          <Text>{record.name}</Text>
        ),

      width: "60%",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      render: (_, record) => (
        <>
          <Text>{record.phone}</Text>
          {record.invalidPhone && (
            <AdnToolTip title={"Invalid number"} color="red" />
          )}
        </>
      ),
      width: "40%",
    },
  ];

  const onCheckDepartment = (e) => {
    if (allSelected) setAllSelected(false);
    setSelectedDepartment(e.target.checked);
    let newSelectedContacts = [...selectedContacts];
    if (e.target.checked) {
      newSelectedContacts = newSelectedContacts.filter(
        (contact) => contact.type != department.name
      );
      newSelectedContacts.push({
        type: "Department",
        id: department.id,
        name: department.name,
        count: totalRecords,
      });
    } else {
      newSelectedContacts = newSelectedContacts.filter(
        (contact) => contact.type != "Department" || contact.id != department.id
      );
    }
    setSelectedContacts(newSelectedContacts);
  };

  const onCheckPage = (e) => {
    let newSelectedContacts = [...selectedContacts];
    for (const record of data) {
      if (e.target.checked) {
        if (
          !newSelectedContacts.find(
            (contact) =>
              contact.id == record.id && contact.type == department.name
          )
        ) {
          newSelectedContacts.push({
            type: department.name,
            id: record.id,
            name: record.name,
            phone: record.phone,
          });
        }
      } else {
        newSelectedContacts = newSelectedContacts.filter(
          (contact) =>
            contact.id != record.id || contact.type != department.name
        );
      }
    }
    setSelectedContacts(newSelectedContacts);
  };

  const onCheck = (e, record) => {
    let newSelectedContacts = [...selectedContacts];
    if (e.target.checked) {
      newSelectedContacts.push({
        type: department.name,
        id: record.id,
        name: record.name,
        phone: record.phone,
      });
    } else {
      newSelectedContacts = newSelectedContacts.filter(
        (contact) => contact.id != record.id || contact.type != department.name
      );
    }
    setSelectedContacts(newSelectedContacts);
  };

  const handleOrderChange = async (pagination, filters, sorter) => {
    sorter.order === "descend"
      ? setOrderBy("-" + sorter.field)
      : sorter.order === "ascend"
      ? setOrderBy(sorter.field)
      : setOrderBy("");
  };

  const handleSearch = (value) => {
    if (value.length > 0) {
      setSearchName(value);
      setCurrentPage(1);
    } else {
      setSearchName("");
    }
  };

  return (
    <ContactPanelForm
      department={department}
      allSelected={allSelected}
      selectedDepartment={selectedDepartment}
      onCheckDepartment={onCheckDepartment}
      selectedCount={selectCount}
      data={data}
      handleSearch={handleSearch}
      columns={columns}
      currentPage={currentPage}
      pageSize={pageSize}
      totalRecords={totalRecords}
      handleChangePage={setCurrentPage}
      handleOrderChange={handleOrderChange}
      {...props}
    />
  );
};

export default ManageContactPanel;
